import React, { useState, useEffect } from 'react';
import { styles } from '../config/styles';

// Componente para la notificación de recordatorio
const Notification = ({ message, onClose }) => {
  const [visible, setVisible] = useState(false);

  // Efecto para controlar la animación de entrada y salida
  useEffect(() => {
    // Aparece
    const showTimer = setTimeout(() => setVisible(true), 100);
    // Desaparece después de 15 segundos
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Llama a onClose después de que la animación de salida termine
      setTimeout(onClose, 500);
    }, 15000); // 15 segundos

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [onClose]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 500);
  };

  return (
    <div className="axon-toast" role="status" style={{ ...styles.notification, ...(visible ? styles.notificationVisible : {}) }}>
      <p style={{ margin: 0, flexGrow: 1 }}>{message}</p>
      <button onClick={handleClose} style={styles.notificationCloseButton} aria-label="Cerrar aviso">
        &times;
      </button>
    </div>
  );
};

export default Notification;
